import { useState, useEffect } from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isArray from "lodash/isArray";
import { Result } from "antd";
import Link from "next/link";
import { searchPage } from "grandus-lib/utils/fetches";
import { getCategoryLinkAttributes } from "grandus-lib/hooks/useFilter";
import { FrownOutlined } from "@ant-design/icons";
import useFilter, {
  getSearchLinkAttributes,
  getSearchLinkAttributesFromRouter,
  paramsToPath,
} from "grandus-lib/hooks/useFilter";
import EnhancedEcommerce from "grandus-lib/utils/ecommerce";
import TagManager from "grandus-lib/utils/gtag";
import Benefits from "components/Benefits";

import Image from "grandus-lib/components-atomic/image/Image";
import ProductCard from "components/product/card/ProductCard";
import Pagination from "components/pagination/Pagination";
import MetaData from "grandus-lib/components-atomic/MetaData";
import Breadcrumbs from "components/breadcrumbs/Breadcrumbs";

import dynamic from "next/dynamic";
import { useRouter } from "next/router";
const CategoryParameters = dynamic(
  () => import("components/category/CategoryParameters"),
  { ssr: false }
);
const CategoryOrdering = dynamic(
  () => import("components/category/CategoryOrdering"),
  { ssr: false }
);
const CategorySelected = dynamic(
  () => import("components/category/CategorySelected"),
  { ssr: false }
);

const handleGetData = (router, newState) => {
  const data = getSearchLinkAttributes(
    get(router, "query.term"),
    paramsToPath(newState),
    get(router, "query"),
    { toDelete: ["term", "parameters", "page"] },
    router
  );

  return data;
};

const handleOrderingLinkAttributes = (router, ordering) => {
  return getSearchLinkAttributesFromRouter(router, {
    dataToChange: { orderBy: ordering },
    toDelete: ["term", "parameters", "page"],
  });
};

const handlePaginationLinkAttributes = (router, data) => {
  return getSearchLinkAttributesFromRouter(router, data);
};

const Search = (props) => {
  const { products, pagination, filter, meta } = props;
  const router = useRouter();
  const [openedFilter, setOpenedFilter] = useState(false);
  const { hasActiveFilters } = useFilter();
  useEffect(() => {
    const list = hasActiveFilters ? "search filter" : "search";
    TagManager.push(
      EnhancedEcommerce.impressions(products, list, {
        page: pagination?.currentPage,
        perPage: pagination?.perPage,
      })
    );
  }, [products, hasActiveFilters]);

  const onClickToggleOpen = () => {
    const body = document.getElementsByTagName("body")[0];
    if (openedFilter) {
      setOpenedFilter(false);
      body.classList.remove("no-scroll");
    } else {
      setOpenedFilter(true);
      body.classList.add("no-scroll");
    }
  };

  return (
    <>
      <MetaData {...meta} />
      <main className="wrapper products">
        <div className="products-container">
          <div className="tabs-section mb1 filter-button">
            <div
              className={`tab-heading hidden-md-up js-tab-heading ${
                openedFilter ? "open" : ""
              }`}
              data-target="#products-filter"
              onClick={onClickToggleOpen}
            >
              {openedFilter ? "Zobraziť produkty" : "Filter produktov"}
            </div>
          </div>
          <aside
            className={`sidebar ${openedFilter ? "open" : ""}`}
            id="products-filter"
            style={{
              minHeight: "100px",
            }}
          >
            <CategoryParameters
              initialData={filter}
              handleGetData={handleGetData}
            />
          </aside>
          <section className="products">
            <Breadcrumbs current="Vyhľadávanie" />
            <h1>Hľadaný výraz: "{get(router, "query.term")}"</h1>

            <CategorySelected handleGetData={handleGetData} />
            <CategoryOrdering
              handleLinkAttributes={handleOrderingLinkAttributes}
            />

            <div className="product-listing-grid" id="layout-grid">
              {isArray(products) && !isEmpty(products) ? (
                <div className="row">
                  {products.map((product, index) => {
                    return (
                      <div
                        className="col-xl-3 col-md-6 column"
                        key={`product-card-${product.id}-${index}`}
                      >
                        <ProductCard
                          {...product}
                          options={{
                            eecProduct: {
                              position: index + 1,
                              page: pagination?.currentPage,
                              perPage: pagination?.perPage,
                            },
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <Result
                  icon={<FrownOutlined />}
                  title="Ľutujeme, nenašli sa produkty"
                  subTitle={`Vášmu výberu nezodpovedaju žiadne produkty. Zmente prosím kategóriu alebo kombináciu filtrov.`}
                />
              )}
            </div>

            <Pagination
              {...pagination}
              handleLinkAttributes={handlePaginationLinkAttributes}
            />
          </section>
        </div>
      </main>

      <Benefits />
    </>
  );
};

export async function getServerSideProps(context) {
  return searchPage.serverSideProps(context);
}

export default Search;
